// client/src/pages/sections/groups/useNameFor.js
// Resolves a user email → real name from /api/diStaffNames (the firm roster, open to any
// signed-in user — /api/diUsers is admin-only). Returns a nameFor(email) function.
//
// The roster is fetched once per page load (deduped by
// staffNamesCache.loadStaffNames). We build a lowercased email→name map at
// module scope so every consumer shares it; each consumer re-renders
// when the map first lands. Falls back to the raw email while loading
// or when an email isn't in the roster (e.g. a partner outside the
// allowlist).

import { useEffect, useState } from 'react';
import { loadStaffNames } from '../../../auth/staffNamesCache';

let cachedMap = null;   // Map<emailLower, name>

export function useNameFor() {
  // Local tick to force a re-render once the map resolves.
  const [, bump] = useState(0);

  useEffect(() => {
    if (cachedMap) return undefined;   // already built — render used it
    let cancelled = false;
    loadStaffNames()
      .then(users => {
        if (cancelled) return;
        const m = new Map();
        for (const u of (users || [])) {
          if (u && u.email) m.set(String(u.email).toLowerCase(), u.name || u.email);
        }
        cachedMap = m;
        bump(n => n + 1);
      })
      .catch(() => { /* keep email fallback on failure */ });
    return () => { cancelled = true; };
  }, []);

  return (email) => {
    if (!email) return email;
    const hit = cachedMap && cachedMap.get(String(email).toLowerCase());
    return hit || email;
  };
}
